"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTx = void 0;
const tools_1 = require("@axiom-crypto/tools");
const utils_1 = require("../utils");
const data_1 = require("./data");
var SpecialTxFields;
(function (SpecialTxFields) {
    SpecialTxFields[SpecialTxFields["Type"] = 51] = "Type";
    SpecialTxFields[SpecialTxFields["BlockNumber"] = 52] = "BlockNumber";
    SpecialTxFields[SpecialTxFields["TxIdx"] = 53] = "TxIdx";
    SpecialTxFields[SpecialTxFields["FunctionSelector"] = 54] = "FunctionSelector";
})(SpecialTxFields || (SpecialTxFields = {}));
;
;
;
const buildTx = (blockNumber, txIdx) => {
    const halo2Lib = globalThis.axiom.halo2lib;
    const getSubquery = (fieldOrCalldataIdx) => {
        let TxSubquery = {
            blockNumber: blockNumber.number(),
            txIdx: txIdx.number(),
            fieldOrCalldataIdx: fieldOrCalldataIdx.number()
        };
        const dataSubquery = { subqueryData: TxSubquery, type: tools_1.DataSubqueryType.Transaction };
        return (0, data_1.prepData)(dataSubquery, [blockNumber, txIdx, fieldOrCalldataIdx]);
    };
    const functions = Object.fromEntries(Object.keys(tools_1.TxField).map((key) => {
        return [(0, utils_1.lowercase)(key), () => {
                const txField = (0, utils_1.getCircuitValueConstant)(tools_1.TxField[key]);
                return getSubquery(txField);
            }];
    }));
    const specialFunctions = Object.fromEntries(Object.keys(SpecialTxFields).map((key) => {
        return [(0, utils_1.lowercase)(key), () => {
                const txField = (0, utils_1.getCircuitValueConstant)(SpecialTxFields[key]);
                return getSubquery(txField);
            }];
    }));
    const calldata = async (calldataIdx) => {
        if (typeof calldataIdx === "string" || typeof calldataIdx === "number" || typeof calldataIdx == "bigint") {
            calldataIdx = (0, utils_1.getCircuitValueConstant)(calldataIdx);
        }
        const logIdxProcessed = (0, utils_1.getCircuitValueWithOffset)(calldataIdx, tools_1.AxiomV2FieldConstant.Tx.CalldataIdxOffset);
        return getSubquery(logIdxProcessed);
    };
    const contractData = async (contractDataIdx) => {
        if (typeof contractDataIdx === "string" || typeof contractDataIdx === "number" || typeof contractDataIdx == "bigint") {
            contractDataIdx = (0, utils_1.getCircuitValueConstant)(contractDataIdx);
        }
        const logIdxProcessed = (0, utils_1.getCircuitValueWithOffset)(contractDataIdx, tools_1.AxiomV2FieldConstant.Tx.ContractDataIdxOffset);
        return getSubquery(logIdxProcessed);
    };
    const allFunctions = { ...functions, ...specialFunctions, calldata, contractData };
    return Object.freeze(allFunctions);
};
exports.buildTx = buildTx;
//# sourceMappingURL=tx.js.map